<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            v-if="isProductsListValid"
            :data="products"
            :description="false"
            @selected="handleSelected5"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="heading">
                {{ $t("setup.label.UsageRatePlan") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="
                    $router.push({
                      name: 'Create Usage Rating',
                    })
                  "
                  size="small"
                  >{{ $t("setup.label.CreateUsageRatePlan") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.Id") }}</vs-th>
              <vs-th>{{ $t("setup.label.PlanName") }}</vs-th>
              <vs-th>{{ $t("setup.label.ProductName") }}</vs-th>
              <vs-th>{{ $t("setup.label.RatePlanName") }}</vs-th>
              <vs-th>{{ $t("setup.label.ChargeCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.TimemodelName") }}</vs-th>
              <vs-th>{{ $t("setup.label.RatingType") }}</vs-th>
              <vs-th>{{ $t("setup.label.RumName") }}</vs-th>
              <!-- <vs-th>{{ $t("label.heading.actions") }}</vs-th> -->
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="products"
                v-for="(products, index) in data"
              >
                <vs-td :data="products.id">{{ products.id }}</vs-td>
                <vs-td :data="products.planDesc">{{ products.planDesc }}</vs-td>
                <vs-td :data="products.productDesc">{{
                  products.productDesc
                }}</vs-td>
                <vs-td :data="products.ratePlanName">{{
                  products.ratePlanName
                }}</vs-td>
                <vs-td :data="products.chargeCode">{{
                  products.chargeCode
                }}</vs-td>
                <vs-td :data="products.timeModelName">{{
                  products.timeModelName
                }}</vs-td>
                <vs-td :data="products.ratingType">{{
                  products.ratingType
                }}</vs-td>
                <vs-td :data="products.rumName">{{ products.rumName }}</vs-td>

                <!-- <vs-td class="whitespace-no-wrap">
                    <feather-icon
                      icon="EditIcon"
                      title="edit"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      @click.stop="editChannelMapping(products.productId)"
                      class="ml-2"
                    />
                  </vs-td> -->
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
      timeList: [],
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      hardwareUomList: (state) => state.usageRating.Uomlist,
      provisioningRumList: (state) => state.usageRating.Rumlist,
      Timemodel: (state) => state.usageRating.GetTimePeriod,
      broadcasters: (state) => state.usageRating.GetTemplate,
      products: (state) => state.usageRating.GetUsageRatePlan,
      timemodel: (state) => state.usageRating.timeModelList,
    }),
    isProductsListValid() {
      return Array.isArray(this.products);
    },
  },
  methods: {
    async getProductMapping() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setUsageRatePlanList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    handleSelected5(provisioningRumList) {
      this.$router.push({
        name: "View Usage Rating",
        params: { id: provisioningRumList.id },
      });
    },
  },
  mounted() {
    this.getProductMapping();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.heading {
  margin-right: auto;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}
</style>
